<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>


    <h3 class="text-left mb-5 text-primary">Test GUI interface</h3>
    <v-row class="d-flex justify-center">
      <v-col md="4" sm="10" cols="12">
        <v-row>
            <v-col cols="12">
	            <v-select v-model="mode"
                :items="['select', 'sign', 'test', 'renew', 'authenticate', 'detect', 'detect-and-install']"
                label="Action"
                outlined
                required
                background-color="white"
                @change="updateRequest(mode,'mode')"
	            />
            </v-col>
            <v-col cols="12" class="py-0">
	            <v-select v-model="showText2SignFormat"
                :items="['', 'text', 'base64']"
                label="TextFormat"
                outlined
                required
                background-color="white"
                @change="updateRequest(showText2SignFormat,'gui','showText2SignFormat')"
	            />

                <v-textarea v-model="textToSign"
                  label="Text to sign"
                  height="100"
                  outlined
                  required
                  background-color="white"
                  @change="updateRequest([textToSign],'signature','dataToSign')"
                />
            </v-col>

            <v-col cols="12">
              <h3 class="text-start mb-2">Providers:</h3>
            </v-col>
            <v-col  cols="12" class="d-flex pt-0">
                <v-checkbox  v-model="desktop.enabled"
                  class="mx-5 pt-0"
                  label="Desktop"
                />
                <v-checkbox v-model="server.enabled"
                  class="mx-5 pt-0"
                  label="Server"
                />
                <v-checkbox v-model="tad.enabled"
                  class="mx-5 pt-0"
                  label="TAD"
                />
            </v-col>
	        
	          <!-- TAD -->
            <v-col cols="12" class="pt-0" :class="{ hidden: !tad.enabled }">
              <h4 class="text-start mb-2">TAD Provider:</h4>
	              <v-layout justify-center>
                <v-text-field v-model="tad.seat"
                  label="seat" outlined
                />
                <v-btn class="mx-2" small dark color="primary" @click="genTadServerToken()">
                  Get Tad Token
                </v-btn>
		              </v-layout>
                <v-text-field v-model="tad.tenant"
                  label="tenant" outlined
                />
                <v-text-field v-model="tad.url"
                  label="server URL" outlined
                />
                <v-text-field v-model="tad.client_key"
                  label="clientID" outlined
                />
                <v-text-field v-model="tad.client_secret"
                  label="clientSecret" type="password" outlined
                />
            </v-col>
	        
	          <!-- SERVER -->
            <v-col cols="12" class="pt-0" :class="{ hidden: !server.enabled }">
              <h4 class="text-start mb-2">Server Provider:</h4>
	              <v-layout justify-center>
                <v-text-field v-model="server.seat"
                  label="seat" outlined
                />
                <v-btn class="mx-2" small dark color="primary" @click="genAlisonServerToken()">
                  Get Server Token
                </v-btn>
		              </v-layout>
                <v-text-field v-model="server.tenant"
                  label="tenant" outlined
                />
                <v-text-field v-model="server.url"
                  label="server URL" outlined
                />
                <v-text-field v-model="server.client_key"
                  label="clientID" outlined
                />
                <v-text-field v-model="server.client_secret"
                  label="clientSecret" type="password" outlined
                />
            </v-col>
	        
	          <!-- SELECTOR -->
            <v-col cols="12" class="py-0">
              <h3 class="text-start mb-2">Selector:</h3>
                <v-text-field
                  v-model="selector.thumbPrint"
                  label="ThumbPrint"
                  outlined
                  background-color="white"
                  @change="updateRequest(selector.thumbPrint,'selector','thumbPrint')"
                ></v-text-field>
                <v-text-field
                  v-model="selector.profileName"
                  label="profileName"
                  background-color="white"
                  outlined
                  @change="updateRequest(selector.profileName,'selector','profileName')"
                ></v-text-field>
                <v-text-field
                  v-model="selector.keyStoreId"
                  label="keyStoreId"
                  background-color="white"
                  outlined
                  @change="updateRequest(selector.profileName,'selector','keyStoreId')"
                ></v-text-field>
            </v-col>
	        
	          <!-- FILTERS -->
            <v-col cols="12" class="py-0">
              <h3 class="text-start">Filters:</h3>
              <div >
                <div class="my-2">
                     <v-btn class="mx-2" dark color="primary" @click="dialogFilter=!dialogFilter">
                        Add filter
                      </v-btn>
                     <v-btn class="mx-2" dark color="primary" @click="filterRequest='[]'">
                        Clean filters
                      </v-btn>
                </div>
                <v-textarea
                  background-color="white"
                  v-model="filterRequest"
                  outlined
                  no-resize
                  height="250"
                  label="Filters">
                </v-textarea>
              </div>
            </v-col>

	          <!-- THEME -->
            <v-col cols="12" class="py-0">
                <h3 class="text-start">Theme:</h3>
		          <div class="mx-4">
                <v-radio-group v-model="theme" background-color="white" row>
                  <v-radio
                    v-for="n in 3"
                    :key="n"
                    :label="`Theme ${n}`"
                    :value="n"
                    background-color="white"
                  />
                </v-radio-group>
          </div>

	          </v-col>
            <v-col cols="12" class="py-0">
                <h3 class="text-start">Palette:</h3>
                <div >
                    <div class="my-2">
                        <v-btn class="mx-2" dark color="primary"
                               @click="setPalette()">
                            Set Palette
                        </v-btn>
                        <v-btn class="mx-2" dark color="primary" @click="unsetPalette()">
                            UnSet Palette
                        </v-btn>
                    </div>
                    <v-textarea v-model="palette"
                            background-color="white"
                            outlined
                            no-resize
                            height="350"
                            label="Palette">
                    </v-textarea>
                </div>
            </v-col>

        </v-row>
      </v-col>
      <v-col md="2" sm="10" cols="12">
        <v-btn
          :disabled="!valid || (!desktop.enabled && !server.enabled  && !tad.enabled)"
          color="primary"
          @click="mountAlisonGui">
          Mount >>
        </v-btn>
          <br/><br/>
          <v-btn color="primary"
                 @click="unmountAlisonGui">
              Unmount
          </v-btn>
      </v-col>
      <v-col md="6" sm="10" cols="12">
        <v-textarea
        background-color="rgba(255,255,255)"
          v-model="operationResult"
          outlined
          no-resize
          height="550"
          label="Result">
        </v-textarea>

          <v-textarea
                  v-model="alisonGUIargs"
                  label="Parameters"
                  outlined
                  required
                  height="750"
                  background-color="#999999"
          ></v-textarea>

      </v-col>

    </v-row>
     <v-dialog
      v-model="dialogFilter"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline primary"
        >
          Filter
        </v-card-title>


        <v-form class="ma-5">
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="issuer"
                      label="Issuer"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="subject"
                      label="Subject"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-select
                  v-model="keystoreFilter"
                  :menu-props="{  maxHeight: 204 }"
                  :items="['WIN-ENH','CSK','ETOKEN','MTOKEN','MACOS','FF-NSS','PFX','CLOUD']"
                  attach
                  label="keystores"
                  multiple
                  outlined
                ></v-select>
                <v-row class="align-start">
                  <v-col cols="4" class="text-start">
                    <p style="color: rgba(0, 0, 0, 0.6);">windowValidity:</p>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <v-text-field
                      v-model="windowValidity.since"
                      class="mt-0 pt-0"
                      single-line
                      :rules="[v => /^\d*\**\-?\d*$/.test(v) || 'value not alowed']"
                      type="text"
                      style="width: 60px"
                      @change="checkValue()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1"  style="color: rgba(0, 0, 0, 0.6);">to</v-col>
                  <v-col cols="2" class="pa-0">
                    <v-text-field
                      v-model="windowValidity.until"
                      class="mt-0 pt-0"
                      single-line
                      :rules="[v => /^\d*\*?\d*$/.test(v) || 'value not alowed']"
                      type="text"
                      style="width: 60px"
                      @change="checkValue()"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                  </v-col>
                </v-row>
            <v-row>
                <v-col>
                    <v-text-field
                            v-model="status"
                            label="Status"
                            outlined
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogFilter=false">Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="addFilter()"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
  import * as testingData from '../datas/testingDatas.js'
  import palette1def from '../assets/palette1.json';

import { mapMutations } from 'vuex'
import alisonGUI from  '../services/alison_gui.js'
  import enviroment from "@/enviroment";

  export default  {
    props: ['certList'],
    data: () => ({
      mode: 'select',
      selector:{
        thumbPrint: "",
        profileName: "",
        keyStoreId: ""
      },
			desktop: {
				enabled: true,
				urls: ['https://127.0.0.1:8004','https://localhost:8004','http://127.0.0.1:8003'],
				token: "eyJ2ZXJzaW9uIjo0LCJ2MSI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6IjMvK0RKMmsxQS9yWjQxL0hlWllYS00ydG1XazE4cDM4RXg0WDdWTWZlYXhpS3dWUHZVRTZzaUh1aHplZThHU1RMR2FwUWRXaFJRNzlyQXRqeWpRWkYxeC83Rm1ZcERzVExnTTQzdDRlV2dMV2NaclQ2Sy9uRGwvc1ltRGtLZjBjWDFtc3JHbkM4RWNQNk9KQW04RGlhUG5ZVlR0ZUpaOVEzbVNJeDk2OGU0cnpJNlF6YUh2L09FQnVmUHhMbTdpMjhQS3JBbHdSS3BQZTFVc3c4eG45NjMxRlJWc1JxaEk1WGFoamRoV2RWQnRkRmg1bE51Y1BUUDVEbFQzdkJIZy94VmV5TllOdVcvRWFobUZiS2RSRS9IRmdEOFN0cnVPTTVvNXJLSHptc2xPbnJFSi8yQkdEa1AxcnF3Nm0wZnlZUTR6K2RpYzdlTHhLWnRsNUNGWGhBR0dLOEdIYXVJVGU5RWUrQUJjN3c1WC8zZkJKVDI4VTgyOEo1V0dOZ0t6TVo5akdsbzVLNVgxOEh1cHVvZ1BGSm9nVjkyV2llbmR5c2JXMmRiZXltcVNINDBTN2kvcDdLb2pRZ2ZyNWtveHl1ZFV1cmgvK1NuYXhYOEczMTF2THU0OUNIalpmdCtycXkvRFlUZFdRS3pYYTFHanZMME5zQkIyNTFRU01OdDdoLzFSYjJkdnNMVk5HcnNKR3BjNFhMWEx1a0J6V1pXSW4zeWd1cDZUMlR0SnhzZCtPSWhtVkxhZldNbHhNME03diJ9LCJ2MiI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6ImV5SmhiR2NpT2lKU1V6STFOaUo5LmV5SnBZWFFpT2pFM05EUXpNVEkyTURVc0ltVjRjQ0k2TVRnME56Y3pOakF3TUN3aVkyOXRjR0Z1ZVU1aGJXVWlPaUpEWlhKMGFWTjFjaUJUTGtFdUlpd2lZV3hzYjNkbFpFOXlhV2RwYm5NaU9sc2lLaTVqWlhKMGFYTjFjaTVqYjIwaUxDSXFMbU5sY25ScGMzVnlMbTVsZENJc0lpb3VZMlZ5ZEdsemRYSXVhVzVtYnlJc0lpb3VkbVZ5YVhOMWNpSXNJaW91ZEc5d2RISjFjM1F1WTI5dExtRnlJaXdpS2k1elpXTjFjbVZrYjJNdWJHRWlMQ0pqYUhKdmJXVXRaWGgwWlc1emFXOXVPaTh2YTNCcWJHRm5aR3B3WVdscGJXNWxZMlJpWkdOdVpHcGphV3B2WVd4aWJHRWlMQ0l4TWpjdU1DNHdMakU2T0RBd015SXNJakV5Tnk0d0xqQXVNVG80TURBMElpd2liRzlqWVd4b2IzTjBPamd3TURNaUxDSnNiMk5oYkdodmMzUTZPREF3TkNJc0lteHZZMkZzYUc5emRDNWpaWEowYVhOMWNpNXVaWFE2T0RBNE1DSmRmUS5Gc09hel9LRWJ2WFh1dkZldXVCWExNYU42dVNjcXF2akt2Vl94dnhrUjQ2eGxuMDZyWnhTby14NElHdjcxajN0dHpERWVXUkQzUTZyV1lfeTViajR3LS0wN1dGRnM4eE8zdVpDUVdfclh3enk5TTJ2bkxIRGdtc0IyNUFPYkhTUVY3QW9iNzRZYTJRcjdlMVFQZldGallpUjlMV3hlVGV0a2dpWTluV2U2MFRoNG5sZC1mbGJSbjVVVnExQ0hqTVBiR3llc0hmSktXSkxZN001NlRIN0pKTno2Q0FNTFIwQkRlSmpodUhJN2ktMkJ2MjRzMmREMFV4Q3ZXU1RJM1piODkyc2xQMVBFdHROWGpvU2tVWVotSlU0WU1GN2tSVDZabnZmR3ZYSjdPQXdnTTFvMFRjR0Q2NGt0bXVySk00dzJoVGZXUDd3SGxXNjFoNE1aamVRcmcifX0="
      },
      server:{
				enabled: false,
	      token: null,
        client_key: enviroment.alisonServerUseClientKey,
        client_secret: enviroment.alisonServerUseClientSecret,
        seat: enviroment.alisonServerSeat,
        tenant: enviroment.alisonServerTenant,
        url: enviroment.alisonServerApiUrl
      },
      tad:{
				enabled: true,
	      token: null,
        client_key: enviroment.tadServerUseClientKey,
        client_secret: enviroment.tadServerUseClientSecret,
        seat: enviroment.tadServerSeat,
        tenant: enviroment.tadServerTenant,
        url: enviroment.tadServerApiUrl
      },
      valid: true,
      theme: 3,
      dialogFilter: false,
      errorMessages: '',
      windowValidity:{since:'*', until:'*'},
      requestPayload: '{}',
      operationResult:'',
	    showText2SignFormat: "text",
	    
      textToSign: 'RXN0byBlcyB1biBlamVtcGxvIGRlIHVuIHRleHRvIHF1ZSBzZSBwdWVkZSBmaXJtYXIuClNlIHB1ZWRlIHBvbmVyIGVuIHZhbGlhcyBsaW5lYXMsIHBlcm8gZGViZSBzZXIgc29sYW1lbnRlIHRleHRvLgpBdW4gbm8gcGVybWl0aW1vcyBwb25lciBIVE1MLgpQb2RlbW9zIHBvbmVyIGNhcmFjdGVyZXMgYWNlbnR1YWRvcyBjb21vIPEgbyDhIApMaW5lYSAxCkxpbmVhIDIKTGluZWEgMwpMaW5lYSA0CkxpbmVhIDUKTGluZWEgNgpMaW5lYSA3CkxpbmVhIDgKTGluZWEgOQpMaW5lYSAxMApMaW5lYSAxMQpMaW5lYSAxMgpMaW5lYSAxMwpMaW5lYSAxNApFc3RhIGVzIGxhIPpsdGltYSBsaW5lYSBjb24gYWNlbnRv',
      subject: '',
      issuer: '',
	    status: 'valid,expired,revoked',
      filterRequest: '[]',
      keystoreFilter: [],
      cuil:'',
        palette: null,
      alisonGUIargs: '{}',
    }),
    watch: {
      filterRequest(value){
        this.updateRequest(JSON.parse(value),'filters')
      },
      theme(value){
          let name = { name: 'theme'+ value }
          this.updateRequest(name,'gui','theme');
      },
      'server.enabled'(value) {
        let request = JSON.parse(this.alisonGUIargs)
        if (value) request.providers.server = this.getServerProvider()
        else delete(request.providers.server);
        this.alisonGUIargs = JSON.stringify(request);
      },
      'tad.enabled'(value) {
        let request = JSON.parse(this.alisonGUIargs)
        if (value) request.providers.tad = this.getTadProvider()
        else delete(request.providers.tad);
        this.alisonGUIargs = JSON.stringify(request);
      },
      'desktop.enabled'(value) {
        let request = JSON.parse(this.alisonGUIargs)
        if (value) request.providers.desktop = this.getDesktopProvider()
        else delete(request.providers.desktop);
        this.alisonGUIargs = JSON.stringify(request);
      }
    },
    mounted() {
      let request = {
        gui: {
          theme: 'theme'+this.theme,
          logo: "./acme/logo.jpg",
          header: "",
          language: {
            key:'es',
            resources: null,
          },
	        showText2SignFormat: this.showText2SignFormat,
	        wizardUrl: "https://desa-desktop.certisur.com/acme"
        },
        mode: this.mode,
        providers: {
          desktop: {
						urls: this.desktop.urls,
            accessToken: this.desktop.token
          },
        },
        signature: {
          dataToSign: [this.textToSign],
          options: {
            algorithm: 'SHA256withRSA',
            format: 'CAdES',
            params: ''
          }
        },
        selector: this.selector,
        filters: JSON.parse(this.filterRequest)
      }
        this.palette = JSON.stringify(palette1def,null, "\t")

        this.alisonGUIargs = JSON.stringify(request,null, "\t")
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor',
	      showSnack: 'showSnack'
      }),
	    
			getDesktopProvider() {
				return {
					accessToken: this.desktop.token,
					urls: this.desktop.urls
				}
			},
			getServerProvider() {
				return {
					token: this.server.token,
					tenant: this.server.tenant,
					userType: 'user',
					url: this.server.url
				}
			},
			getTadProvider() {
				return {
					token: this.tad.token,
					tenant: this.tad.tenant,
					url: this.tad.url
				}
			},

        setPalette() {
            let theme = {
                name: "theme"+this.theme,
                palette: JSON.parse(this.palette)
            }
            this.updateRequest(theme,'gui','theme');
        },
        unsetPalette() {
            let theme = {
                name: "theme"+this.theme
            }
            this.updateRequest(theme,'gui','theme');
        },

      changeCuil(value){
        let request = JSON.parse(this.alisonGUIargs);
        request.providers.tad = value;
        this.alisonGUIargs = JSON.stringify(request,null, "\t")
      },
      updateRequest(value,key,secundaryKey){
        let request = JSON.parse(this.alisonGUIargs);
        if(secundaryKey){
          request[key][secundaryKey] = value
        } else {
          request[key] = value
        }
        this.alisonGUIargs = JSON.stringify(request,null, "\t")
      },
        unmountAlisonGui () {
            alisonGUI.unmount();
        },
      async mountAlisonGui () {
        if (this.$refs.form.validate()) {
            let request = JSON.parse(this.alisonGUIargs)
            request.onConfirm = (result) => {
                this.setColor('success')
                this.setSnack('Signed successfully')
                this.operationResult = JSON.stringify(result,null, "\t");
            }
            request.onCancel = (result) => {
                this.setColor('error')
                this.setSnack('CANCEL')
                this.operationResult = JSON.stringify(result,null, "\t");
                console.log("CANCEL");
            }
            alisonGUI.mount(request);
        }
      },
      checkValue(){
        if(this.windowValidity.since==='') this.windowValidity.since ='*'
        if(this.windowValidity.until==='') this.windowValidity.until ='*'
      },
      addFilter(){
        const newFilter = {
              keyStores: this.keystoreFilter.length > 0 ? this.keystoreFilter : null,
              windowValidity: (this.windowValidity.since && this.windowValidity.until) ? this.windowValidity.since +","+this.windowValidity.until : null,
              subject: this.subject,
              issuer: this.issuer,
              status: this.status
            }
        let filters = JSON.parse(this.filterRequest)
        filters.push(newFilter)
        this.filterRequest = JSON.stringify(filters,null, "\t");
        this.dialogFilter = false
      },
      async genAlisonServerToken() {
        try {
              const serverResponse = await alisonGUI.serverToken({
                client_id: this.server.client_key,
                client_secret: this.server.client_secret,
                grant_type: 'client_credentials',
                scope: `seat:${this.server.seat}`
              })
	            this.server.token = serverResponse.access_token;
              let request = JSON.parse(this.alisonGUIargs)
              this.setColor('success')
              this.setSnack('Generated access token')
	            request.providers.server = this.getServerProvider();
              this.alisonGUIargs = JSON.stringify(request);
          } catch (err) {
              console.log("error")
              this.setColor('error')
              this.setSnack('Error getting access token')
              this.operationResult = JSON.stringify(err,null, "\t");
          }
      },
      async genTadServerToken() {
        try {
					const serverResponse = await alisonGUI.serverToken({
						client_id: this.tad.client_key,
						client_secret: this.tad.client_secret,
						grant_type: 'client_credentials',
						scope: `seat:${this.tad.seat}`
					})
					console.log('-------->',serverResponse);
					this.tad.token = serverResponse.access_token;
					let request = JSON.parse(this.alisonGUIargs)
					this.setColor('success')
					this.setSnack('Generated TAD token')
					request.providers.tad = this.getTadProvider();
					this.alisonGUIargs = JSON.stringify(request);
				} catch (err) {
					console.log('-------2->',err);
					this.setColor('error')
					this.setSnack('Error getting access token')
					this.operationResult = JSON.stringify(err,null, "\t");
        }
      },
    },
  }
</script>
<style scoped>
  .v-expansion-panel-header{
    background-color: #007CA4;
  }
  .hidden{
    display:none;
  }
</style>
